export default "__VITE_ASSET__DPYjDWsv__"